import { Controller } from 'stimulus';

import { copyToClipboard } from '../models/helpers';

export default class extends Controller {
  static targets = ['link', 'successText'];

  declare readonly linkTarget: HTMLInputElement;

  declare readonly successTextTarget: HTMLElement;

  connect() {
    if (!this.successTextTarget.ariaLive) {
      this.successTextTarget.ariaLive = 'polite';
    }
  }

  copy(e: KeyboardEvent) {
    e.preventDefault();
    if (this.isClick(e) || this.isEnterKeydown(e)) {
      copyToClipboard(this.linkTarget);
      this.successTextTarget.innerHTML = '';
      this.successTextTarget.append(this.successTextTarget.dataset.successMessage || 'Copied');
    }
  }

  isClick(event: Event) {
    return event.type === 'click';
  }

  isEnterKeydown(event: KeyboardEvent) {
    return event.type === 'keydown' && (event.code === 'Enter' || event.keyCode === 13);
  }
}
